import React from 'react';
import { matchPath, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PageOptionType } from '@app/component/tabs/PageTabs';

type PageTabsProps = {
	options: PageOptionType[],
	isOutlet?: boolean
}

const PageButtonTabs: React.FunctionComponent<PageTabsProps> = ({ options, isOutlet = false }) => {

	const activeClassNames = 'bg-blue-100 text-blue-700 rounded-md px-3 py-1.5 text-sm font-medium';
	const inactiveClassNames = 'text-gray-500 hover:text-gray-700 rounded-md px-3 py-1.5 text-sm font-medium';
	const disabledClassNames = 'text-gray-300 rounded-md px-3 py-1.5 text-sm font-medium cursor-not-allowed';

	const location = useLocation();
	const navigate = useNavigate();

	const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		navigate(event.target.value);
	};

	const isTabActive = (url: string, isRouter = false) => {
		return !!matchPath(url + (isRouter ? '/*' : ''), location.pathname);
	};

	return <>
		<div className="mb-6">
			<div className="grid grid-cols-1 sm:hidden">
				<select aria-label="Select a tab"
								value={location.pathname}
								onChange={handleSelectChange}
								className="col-start-1 row-start-1 w-full input">
					{options.map(o => <option key={o.label} id={o.label} value={o.link} disabled={o.disabled}>{o.label}</option>)}
				</select>
			</div>
			<div className="hidden sm:block">
				<nav className="flex space-x-4" aria-label="Tabs">
					{options.map(o => <button key={o.label}
																		onClick={() => navigate(o.link)}
																		disabled={o.disabled}
																		className={o.disabled ? disabledClassNames : isTabActive(o.match || o.link, o.isRouter) ? activeClassNames : inactiveClassNames}>
						{o.label}
					</button>)}
				</nav>
			</div>
		</div>
		{isOutlet ? <Outlet /> : options.find(o => isTabActive(o.link, o.isRouter))?.fragment}
	</>;
};

export default PageButtonTabs;
